import * as React from "react"
import { Flex } from "@chakra-ui/react"
import { Icon } from "../../common/icons"
import { IoClose } from "react-icons/io5"
import { ChatStyles } from "./index"

interface ChatCloseIconProps {
  callback: any
  id?: string
  isMobile: boolean
  styleschat: ChatStyles
  isLarge?: boolean
}

const _ChatCloseIcon: React.FC<ChatCloseIconProps> = ({
  callback,
  id,
  isMobile,
  styleschat,
  isLarge
}) => {

  let width, height, fontSize, right, top
  if (isLarge) {
    width = "24px"
    height = "24px"
    fontSize = "1.2rem"
    right = "-10px"
    top = "-10px"
  }

  return (
    <Flex
      backgroundColor={styleschat?.secondaryAccessButtonBackgroundColor}
      border={
        styleschat?.secondaryAccessButtonBorderColor
          ? `1px solid ${
              styleschat?.secondaryAccessButtonBorderColor
                ? styleschat.secondaryAccessButtonBorderColor
                : "transparent"
            }`
          : "0px"
      }
      textColor={styleschat?.secondaryAccessButtonTextColor ?? "#FFFFFF"}
      _hover={{
        backgroundColor:
          styleschat?.secondaryAccessButtonMouseoverColor ?? "#24A840",
        textColor:
          styleschat?.secondaryAccessButtonTextMouseoverColor ?? "#FFFFFF"
      }}
      pos={isMobile ? "relative" : "absolute"}
      width={width || (isMobile ? "18.4px" : "13px")}
      marginTop={isMobile && "1px"}
      height={height|| (isMobile ? "18.4px" : "13px")}
      borderRadius="50%"
      right={right ?? (!isMobile && "-7.3px")}
      top={top ?? (!isMobile && "-7.4px")}
      marginLeft={isMobile && "auto"}
      alignItems="center"
      justifyContent="center"
      onClick={() => callback(id)}
      cursor={"pointer"}
      zIndex={1}
    >
      <Icon
        src={IoClose}
        marginRight="-50%"
        transform="translate(-50%, -50%)"
        top="50%"
        left="50%"
        pos="absolute"
        fontSize={fontSize || (isMobile ? "0.95rem" : "0.6rem")}
        opacity={0.8}
        _hover={{
          opacity: 1
        }}
      />
    </Flex>
  )
}

export const ChatCloseIcon = React.memo(_ChatCloseIcon)
